import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { livyJson } from 'src/lib/livyApi';
/**
 * What this surface can do, grouped, for the composer's + menu. A handful of starters understated
 * it badly: the assistant reaches dozens of tools and advertised four questions.
 *
 * The groups come from the server, matched against the caller's own allowlist, so this cannot offer
 * a resident something only staff can reach, and cannot go stale when a tool is added.
 */
export function useCapabilities(surface, enabled) {
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    groups = _useState2[0],
    setGroups = _useState2[1];
  useEffect(() => {
    setGroups([]);
    if (!enabled) return undefined;
    let live = true;
    livyJson("/capabilities?surface=".concat(encodeURIComponent(surface)))
    // A failure here costs the reader a menu, not the chat: the composer still works.
    .then(d => live && setGroups(Array.isArray(d === null || d === void 0 ? void 0 : d.groups) ? d.groups : [])).catch(() => live && setGroups([]));
    return () => {
      live = false;
    };
  }, [surface, enabled]);

  // Switched off (a customer view), it must not keep showing the staff catalog it fetched earlier.
  return enabled ? groups : [];
}

/**
 * Whether this surface answers as Livable support: the proxy says so per caller (off for customers until the
 * support setting is on; on for staff previewing the customer view). Cosmetic: the proxy decides every turn.
 */
export function useSupportChat(surface, enabled) {
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    on = _useState4[0],
    setOn = _useState4[1];
  useEffect(() => {
    setOn(false);
    if (!enabled) return undefined;
    let live = true;
    livyJson("/capabilities?surface=".concat(encodeURIComponent(surface))).then(d => live && setOn((d === null || d === void 0 ? void 0 : d.support) === true)).catch(() => live && setOn(false));
    return () => {
      live = false;
    };
  }, [surface, enabled]);
  return enabled && on;
}